import Vue from 'vue';
import jwt_decode from "jwt-decode";
import dateFormatter from './date';

Vue.mixin({
    computed: {
        is_dark() {
            return true;
            //return this.$config.DARK_MODE?true:false;
        },
        site_name() {
            return this.$config.SITE_NAME;
        },
        currency() {
            return _.get(this.user, 'currency', this.$config.DEFAULT_CURRENCY);
        },
        lang() {
            return _.toString(this.$i18n.locale).slice(0, 2);
        },
        operator_app() {
            if(this.platform === 'ios')
                return 'ios_sport';
            if(this.platform === 'android')
                return 'android_sport';
            if(this.system === 'app')
                return 'ios_sport';
            return 'default';
        },
        platform() {
          if (this.$route.query.platform) {
            return this.$route.query.platform;
          }
          if (process.client && navigator.userAgent.includes("SportifyApp")) {
            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
            if (isIOS) {
              return "ios";
            } else {
              return "android";
            }
          }
          return this.$store.state.platform;
        },
        system() {
          if (process.client && navigator.userAgent.includes("SportifyApp")) {
            return "app";
          }
          return this.$config.SYSTEM;
        },
        operatingSystem() {
            return this.$store.state.operatingSystem;
        },
        appReady() {
          if (process.client && this.system === "app") return true;
          return this.$store.state.appReady;
        },
        appState() {
            return this.$store.state.appState;
        },
        general() {
            return this.$store.state.globals_new;
        },
        country() {
          return this.$store.state.country
            ? this.$store.state.country
            : this.$config.COUNTRY;
        },
        user() {
            return this.$store.state.auth.user;
        },
        jwt() {
            return this.$store.state.auth.jwt;
        },
        locationAllowed() {
            return this.$store.state.locationAllowed;
        },
        loginToken() {
            return this.$store.state.auth.loginToken;
        },
        sessionToken() {
            return this.$store.state.auth.sessionToken;
        },
        seoTags() {
            return this.$store.state.seo;
        },
        showBetBuilder() {
            if(_.get(this.$store, 'state.betslipType') === 'betbuilder')
                return true;
            /*if(_.get(this.$store, 'state.betbuilder.updatedAt') != null && _.get(this.$store, 'state.betslip.updatedAt') == null)
                return true;
            if(_.get(this.$store, 'state.betbuilder.updatedAt') > _.get(this.$store, 'state.betslip.updatedAt'))
                return true;*/
            return false;
        },
    },
    methods: {
      get_event_id: function (string) {
        return string.split('-').pop();
      },
      getEventId: function (str = null) {
        var index = str.lastIndexOf("-");
        return str.substr(index+1);
      },
      epoch: function(datetime) {
        let params = {
          today_text: this.$t(this.$config.TODAY_TEXT),
          tomorrow_text: this.$t(this.$config.TOMORROW_TEXT),
          starts_in_less_than: this.$t('Starts in less than'),
          starting_soon: this.$t('Starting soon'),
          minutes: this.$t('minutes'),
          hours: this.$t('hours')
        }
        return new dateFormatter(datetime, params)
      },
      $date: function (string = null) {
        return this.epoch(string).setLocale(this.$i18n.locale).setTimezone(this.$store.state.settings.timezone)
      }
    }
})
